export default __webpack_public_path__ + "static/media/modern-background-large.344c3fa9.jpg";